import React from "react";
import { CURRENT_USER } from "../services/currentUser";
import { signOut } from "../services/auth";
import { useUnreadTexts } from "../services/communications";
import "./Sidebar.css";

const SECTIONS = [
  {
    title: null,
    items: [["dashboard", "🏠 Dashboard"]],
  },
  {
    title: "SALES",
    items: [
      ["communications", "📞 Communications"],
      ["rebook", "🔄 Rebook"],
      ["tasks", "✓ Tasks"],
      ["leads", "📊 Lead Center"],
      ["quotes", "💬 Quotes"],
    ],
  },
  {
    title: "FIELD",
    items: [
      ["route", "🗺️ Route"],
      ["calls", "📱 Calls"],
      ["inspection", "🔍 Inspection"],
    ],
  },
  {
    title: "JOB PROGRESS",
    items: [
      ["jobsProgress", "🛠️ Jobs in Progress"],
      ["jobsCompleted", "✅ Completed Jobs"],
    ],
  },
  {
    title: "INSIGHTS",
    items: [
      ["analytics", "📈 Analytics"],
      ["resources", "📚 Resources"],
    ],
  },
  {
    title: null,
    items: [
      ["pay", "💳 Pay Tracker"],
      ["settings", "⚙️ Settings"],
    ],
  },
];

export default function Sidebar({ currentPage = "route", onPageChange = () => {} }) {
  // customers whose texts nobody has opened yet
  const unreadTexts = useUnreadTexts();
  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {SECTIONS.map((section, i) => (
          <div className="nav-section" key={section.title || i}>
            {section.title && <div className="nav-section-title">{section.title}</div>}
            <div className="nav-items">
              {section.items.map(([page, label]) => (
                <div
                  key={page}
                  role="button"
                  tabIndex={0}
                  className={`nav-item ${currentPage === page ? "active" : ""}`}
                  onClick={() => onPageChange(page)}
                  onKeyDown={(e) => e.key === "Enter" && onPageChange(page)}
                >
                  {label}
                  {page === "communications" && unreadTexts > 0 && (
                    <span className="nav-badge" aria-label={`${unreadTexts} unread`}>{unreadTexts}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* who's signed in */}
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="avatar">{CURRENT_USER.initials}</div>
          <div className="user-info">
            <div className="user-name">{CURRENT_USER.name}</div>
            <div className="user-role">{CURRENT_USER.role.toUpperCase()}</div>
          </div>
        </div>
        <button type="button" className="sign-out-btn" onClick={signOut}>
          Sign out
        </button>
      </div>
    </aside>
  );
}
